import type { HomePageLocations } from '@/types/ga4/tracking-locations'

export const HOME_HERO_LOCATION = 'home_hero'
export const HOME_CTA_BANNER_LOCATION = 'home_cta_banner'
export const HOME_BLOG_CAROUSEL_LOCATION = 'home_blog_carousel'
export const HOME_TESTIMONIALS_LOCATION = 'home_testimonials'
export const HOME_FAQ_LOCATION = 'home_faq'

export const HOME_PAGE_LOCATIONS = {
	hero: HOME_HERO_LOCATION,
	ctaBanner: HOME_CTA_BANNER_LOCATION,
	blogCarousel: HOME_BLOG_CAROUSEL_LOCATION,
	testimonials: HOME_TESTIMONIALS_LOCATION,
	faq: HOME_FAQ_LOCATION
} as const satisfies HomePageLocations
